import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../api";
import { toast } from "sonner";

const fmtBytes = (n) => {
  if (!n && n !== 0) return "—";
  const u = ["B", "KB", "MB", "GB", "TB"];
  let i = 0;
  let v = n;
  while (v >= 1024 && i < u.length - 1) {
    v /= 1024;
    i++;
  }
  return `${v.toFixed(1)} ${u[i]}`;
};

const countdown = (iso) => {
  if (!iso) return "—";
  const ms = new Date(iso) - new Date();
  if (ms < 0) return "expired";
  const m = Math.floor(ms / 60000);
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ${m % 60}m`;
  return `${Math.floor(h / 24)}d ${h % 24}h`;
};

export default function Storage() {
  const [rows, setRows] = useState([]);

  const load = async () => {
    const { data } = await api.get("/admin/s3-objects");
    setRows(data);
  };

  useEffect(() => {
    load();
    const id = setInterval(load, 15_000);
    return () => clearInterval(id);
  }, []);

  const onDelete = async (key) => {
    if (!confirm(`Force-delete ${key}?`)) return;
    try {
      await api.delete(`/admin/s3-objects/${encodeURIComponent(key)}`);
      toast.success("Deleted");
      load();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  return (
    <div className="space-y-6" data-testid="storage-page">
      <div className="flex items-baseline justify-between">
        <h1 className="font-display text-3xl tracking-tight">Storage</h1>
        <div className="text-xs font-mono text-muted-foreground">
          {rows.length} objects
        </div>
      </div>

      <div className="border border-border" data-testid="storage-table">
        <div className="grid grid-cols-[1fr_120px_120px_180px_120px] gap-4 px-4 py-2.5 text-[10px] font-mono uppercase tracking-[0.18em] text-muted-foreground border-b border-border bg-secondary/20">
          <div>Key</div>
          <div>Size</div>
          <div>Expires</div>
          <div>Created</div>
          <div className="text-right">Actions</div>
        </div>
        {rows.length === 0 && (
          <div className="px-4 py-12 text-center text-sm text-muted-foreground">
            No objects.
          </div>
        )}
        {rows.map((o) => (
          <div
            key={o.key}
            data-testid={`s3-row-${o.key}`}
            className={`grid grid-cols-[1fr_120px_120px_180px_120px] gap-4 px-4 py-2.5 text-sm border-b border-border last:border-b-0 ${
              o.deleted ? "opacity-50" : ""
            }`}
          >
            <div className="truncate font-mono text-xs">{o.key}</div>
            <div className="font-mono text-xs">{fmtBytes(o.size_bytes)}</div>
            <div className="font-mono text-xs">{countdown(o.expires_at)}</div>
            <div className="font-mono text-xs text-muted-foreground">
              {new Date(o.created_at).toLocaleString()}
            </div>
            <div className="text-right">
              {!o.deleted && (
                <button
                  onClick={() => onDelete(o.key)}
                  data-testid={`s3-delete-${o.key}`}
                  className="px-2.5 py-1 text-xs border border-border hover:text-red-400 transition-colors"
                >
                  Force delete
                </button>
              )}
              {o.deleted && (
                <span className="text-[10px] font-mono uppercase text-muted-foreground">
                  deleted
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
